import { render } from "./tab-kompetensi-profesi.vue?vue&type=template&id=c86f6966&scoped=true"
import script from "./tab-kompetensi-profesi.vue?vue&type=script&lang=js"
export * from "./tab-kompetensi-profesi.vue?vue&type=script&lang=js"

import "./tab-kompetensi-profesi.vue?vue&type=style&index=0&id=c86f6966&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c86f6966"]])

export default __exports__